import styled from "styled-components";

import { ReactComponent as star } from "../../assets/icons/star.svg";

export const StarContainer = styled.div`
  display: flexbox;
  flex-direction: row;
  width: 15px;
  height: 15px;
  margin: 0 5px 20px 0;
  .ratingStars {
    display: flexbox;
    flex-direction: row;
    width: 15px;
    height: 15px;
    margin: 0 5px 20px 0;
  }
`;

export const Icons = styled.div``;
Icons.StarsIcon = styled(star)`
  cursor: pointer;
  display: flex;
  flex-direction: row;

  fill: ${(props) => (props.color ? props.color : "#EBEBEB")};
  & path {
    stroke: ${(props) => (props.color ? props.color : "#bababa")};
  }
`;
